// extracted by mini-css-extract-plugin
module.exports = {"powerstream-cooperation-F":"F_powerstream-cooperation-F__t3j4G"};